import React from 'react';
import { EnumCell } from '@monorepo/ui-kit';
import { enumToSelectOptions } from '@monorepo/helpers';
import { useI18n } from '@monorepo/i18n';
import { PAYMENT_CONDITION } from '../../constants';

type TProps = {
  value: string | number;
  defaultValue: string;
};

const PaymentConditionEnum: Component<TProps> = ({ value, defaultValue }) => {
  const { t } = useI18n();
  return (
    <EnumCell
      dictionary={
        enumToSelectOptions(PAYMENT_CONDITION, false, (item) =>
          t(`paymentcondition.${item}`)
        ) as any
      }
      value={value}
      defaultValue={defaultValue}
    />
  );
};

export default PaymentConditionEnum;
